/* eslint-env browser */
import Vue from "vue";
import { mapGetters } from "vuex";

Vue.component("notification-component", {
  props: ["notificationData"],
  template: `<div class="c-notification" v-bind:class="cClass">
                <div class="c-notification__content">
                  <div class="c-notification__close" v-if="notificationData.closeButton" v-on:click="close">&times;</div>
                  <div class="c-notification__title" v-if="notificationData.title" v-html="notificationData.title"></div>
                  <div v-if="notificationData.type === 'welcome'" style="padding:56.25% 0 0 0;position:relative;">
                    <iframe src="https://player.vimeo.com/video/269867331?autoplay=0&color=ffffff&title=0&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                  </div>
                  <div class="c-notification__message" v-html="notificationData.content"></div>
                  <div class="c-notification__footer" v-html="notificationData.footer"></div>

                  
                  <div class="c-notification__games" v-if="gamesList.length">
                    <a v-for="game in gamesList" :href="game.link">
                      <img :src="game.image">
                    </a>
                  </div>
                 

                  
                  <div v-if="notificationData.action.text !== ''">

                    <a v-if="notificationData.type === 'welcome'" class="btn prominent btn-l3 btn--margin-top" v-on:click="close">{{ notificationData.action.text }}</a>

                    <a v-on:click="ctaTracking" class="btn prominent btn-l3 btn--margin-top"
                      v-if="notificationData.action && notificationData.type !== 'welcome' && !getIsNative"
                      v-bind:href="notificationData.action.url"
                    >{{ notificationData.action.text }}</a>

                    <a v-on:click="ctaTracking" class="btn prominent btn-l3 btn--margin-top"
                      v-if="notificationData.action && notificationData.type !== 'welcome' && getIsNative"
                      v-bind:href="notificationData.action.native"
                    >{{ notificationData.action.text }}</a>

                    
                  </div>

              </div>
            </div>`,
  computed: {
    ...mapGetters([
      "getIsMobile",
      "getIsNative",
      "getLanguage",
      "getPortal",
      "getGamesData"
    ]),
    cClass() {
      return `c-notification__${this.notificationData.type}`;
    },
    gamesList() {
      
      return this.getGames(this.notificationData.showGames);
    }
  },
  methods: {
    getDevice() {
      if (this.getIsNative) return "native";
      if (this.getIsMobile) return "mobile";

      return "desktop";
    },
    generateGameLink(gameCodes, device) {
      let lang = this.getLanguage === "en_uk" ? "en" : this.getLanguage;

      if (device === "desktop") {
        if (["bwin.es", "bwin.se", "bwin.be", "bwin.dk", "bwin.gr"].includes(this.getPortal)) {
          return (
            "https://casino." +
            this.getPortal +
            "/" +
            lang +
            "/games/launchEmbedded/" +
            gameCodes[device] +
            "?forcedEmbeddedLaunch=true"
          );
        } else {
          return (
            "https://casino." +
            this.getPortal +
            "/" +
            lang +
            "/casino/?opengame=" +
            gameCodes[device]
          );
        }
      }
      if (device === "mobile")
        if (["bwin.com", "premium.com"].includes(this.getPortal)) {
          return (
            "https://casino.m." +
              this.getPortal +
              "/" +
              lang +
              "/games/launchng/" +
              gameCodes[device]
          );
        } else {
          return (
            "https://casino.m." +
              this.getPortal +
              "/" +
              lang +
              "/casino/launchng/" +
              gameCodes[device]
          );
        }

      if (device === "native")
        return "bwincomcpt://Casino?gameID=" + gameCodes["desktop"];
    },
    getGames(code) {
      let gamesList = [];
      
      let device = this.getDevice();
      
      if (typeof codesGames[code] !== "undefined") {
        codesGames[code].forEach(gameName => {
          gamesList.push({
            image: this.getGamesData[gameName].image,
            link: this.generateGameLink(this.getGamesData[gameName], device)
          });
        });
      }

      return gamesList;
    },
    close() {
      const self = this;
      self.$emit("close");
      dataLayer.push({
        event: "Event.Functionality.",
        "page.referringAction": `coin-flip_${
          this.notificationData.type
        }Message_Close`
      });
    },
    ctaTracking() {
      dataLayer.push({
        event: "Event.Functionality.",
        "page.referringAction": `coin-flip_${
          this.notificationData.type
        }_CTA_Clicked`
      });
    }
  },
  mounted() {
    this.$nextTick(function() {
      this.gamesList();
    })
    const self = this;
    if (!this.notificationData.stayOpen) {
      setTimeout(self.close, this.notificationData.duration);
    }
  }
});



// WEBPACK FOOTER //
// ./app/js/components/notifications/notification-component.js